module.exports = __webpack_public_path__ + "img/icon-tenant-active.15a10e41.svg";